<!--
 * @message: 排班格子底部线条
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2021-06-20 17:34:46
 * @FilePath: \mrc-ess-fronted\src\components\MRC_ESS_Card_Line.vue
 * @最后编辑: Betway
 * @最后修改时间: 2021-12-16 18:09:30
-->
<template>
  <v-sheet
    class="max-width rounded-lg"
    :style="{
      overflow: 'hidden',
      border: !isFuture ? '1px solid #f5f5f7' : 'none',
    }"
  >
    <v-sheet
      class="max-width transparent"
      v-if="
        !(
          Number(Master.is_late) ||
          Number(Master.is_early_leave) ||
          Number(Master.is_absense) ||
          Number(Master.is_missing_punch) ||
          Number(Master.is_ot)
        )
      "
    >
      <v-sheet
        class="max-width rounded-lg d-flex justify-start"
        tile
        v-if="Master && !isFuture"
        :elevation="0"
        :color="
          Number(Master.is_late) ||
          Number(Master.is_early_leave) ||
          Number(Master.is_absense) ||
          Number(Master.is_missing_punch) ||
          Number(Master.is_ot)
            ? 'black'
            : 'green'
        "
        :height="4"
      >
        <v-sheet
          width="20%"
          height="100%"
          :color="
            Number(Master.is_late) ? getColors('is_late_1') : 'transparent'
          "
        ></v-sheet>
        <v-sheet
          width="20%"
          height="100%"
          :color="Number(Master.is_ot) ? getColors('is_ot_1') : 'transparent'"
        ></v-sheet>
        <v-sheet
          width="20%"
          height="100%"
          :color="
            Number(Master.is_early_leave)
              ? getColors('is_early_leave_1')
              : 'transparent'
          "
        ></v-sheet>
        <v-sheet
          width="20%"
          height="100%"
          :color="
            Number(Master.is_absense)
              ? getColors('is_absense_1')
              : 'transparent'
          "
        ></v-sheet>
        <v-sheet
          width="20%"
          height="100%"
          :color="
            Number(Master.is_missing_punch)
              ? getColors('is_missing_punch_1')
              : 'transparent'
          "
        ></v-sheet>
      </v-sheet>
    </v-sheet>
    <v-tooltip bottom color="rgba(0,0,0,0.4)" v-else>
      <template v-slot:activator="{ on, attrs }">
        <!-- <v-sheet
        class="max-width rounded-lg align-end"
        tile
        v-bind="attrs"
        v-on="on"
        v-if="Master && !isFuture"
        :elevation="0"
        :color="
          Number(Master.is_late) ||
          Number(Master.is_early_leave) ||
          Number(Master.is_absense) ||
          Number(Master.is_missing_punch)
            ? 'red'
            : 'green'
        "
        :height="6"
      /> -->
        <v-sheet
          class="max-width rounded-lg d-flex justify-start"
          tile
          v-bind="attrs"
          v-on="on"
          v-if="Master && !isFuture"
          :elevation="0"
          :color="
            Number(Master.is_late) ||
            Number(Master.is_early_leave) ||
            Number(Master.is_absense) ||
            Number(Master.is_missing_punch) ||
            Number(Master.is_ot)
              ? 'black'
              : 'green'
          "
          :height="4"
        >
          <v-sheet
            class="flex-shrink-1"
            width="20%"
            height="100%"
            :color="
              Number(Master.is_late) ? getColors('is_late_1') : 'transparent'
            "
          ></v-sheet>
          <v-sheet
            width="20%"
            class="flex-shrink-1"
            height="100%"
            :color="
              Number(Master.is_early_leave)
                ? getColors('is_early_leave_1')
                : 'transparent'
            "
          ></v-sheet>
          <v-sheet
            class="flex-shrink-1"
            width="20%"
            height="100%"
            :color="Number(Master.is_ot) ? getColors('is_ot_1') : 'transparent'"
          ></v-sheet>
          <v-sheet
            class="flex-shrink-1"
            width="20%"
            height="100%"
            :color="
              Number(Master.is_absense)
                ? getColors('is_absense_1')
                : 'transparent'
            "
          ></v-sheet>
          <v-sheet
            width="20%"
            class="flex-shrink-1"
            height="100%"
            :color="
              Number(Master.is_missing_punch)
                ? getColors('is_missing_punch_1')
                : 'transparent'
            "
          ></v-sheet>
        </v-sheet>
      </template>
      <v-sheet
        color="transparent"
        class="rounded-lg d-flex flex-row justify-start pa-0"
      >
        <v-sheet class="transparent d-flex align-center px-1">
          <svg-icon
            size="16"
            :fill="getColors('is_late_1')"
            iconClass="LabeledColour"
          />
          <span class="white--text">{{
            $t("label_essweb_system_tag_label_lateLabel")
          }}</span>
        </v-sheet>
        <v-sheet class="transparent d-flex align-center px-1">
          <svg-icon
            size="16"
            :fill="getColors('is_early_leave_1')"
            iconClass="LabeledColour"
          />
          <span class="white--text">{{
            $t("label_essweb_system_tag_label_earlyLeaveLabel")
          }}</span>
        </v-sheet>
        <v-sheet class="transparent d-flex align-center px-1">
          <svg-icon
            size="16"
            :fill="getColors('is_ot_1')"
            iconClass="LabeledColour"
          />
          <span class="white--text">{{
            $t("label_essweb_system_tag_label_otLabel")
          }}</span>
        </v-sheet>
        <v-sheet class="transparent d-flex align-center px-1">
          <svg-icon
            size="16"
            :fill="getColors('is_absense_1')"
            iconClass="LabeledColour"
          />
          <span class="white--text">{{
            $t("label_essweb_system_tag_label_absenseLabel")
          }}</span>
        </v-sheet>
        <v-sheet class="transparent d-flex align-center px-1">
          <svg-icon
            size="16"
            :fill="getColors('is_missing_punch_1')"
            iconClass="LabeledColour"
          />
          <span class="white--text">{{
            $t("label_essweb_system_tag_label_isMissingPunchLabel")
          }}</span>
        </v-sheet>
      </v-sheet>
    </v-tooltip>
  </v-sheet>
</template>
<script>
import Vue from "vue";
import { mapGetters } from "vuex";
export default {
  name: "Card_Line",
  computed: {
    ...mapGetters(["companyLang"]),
  },
  props: {
    isFuture: { default: false, type: [Number, Boolean] },
    Master: { default: null, type: [Object, String, Array] },
  },
  data() {
    return {
      colors: [],
      show: true,
    };
  },
  mounted() {
    if (!this.$card_line_colors || this.$card_line_colors.length == 0) {
      this.getPromptData();
    } else {
      this.colors = this.$card_line_colors;
    }
  },
  methods: {
    getColors(code) {
      const that = this;
      if (this.colors) {
        let color = this.colors.find(
          (ele) => ele["value_field"] === code.toString()
        );
        if (color) return color["f1"];
        else return "transparent";
      } else {
        return "transparent";
      }
    },
    getPromptData: function (name) {
      const that = this;
      this.$findPrompt({
        prompt_name: "ess_attendance_status_select",
      }).then((res) => {
        Vue.prototype.$card_line_colors = res.data;
        that.colors = res.data;
      });
    },
  },
};
</script>